import _slicedToArray from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import { Box } from '../Box';
import { wrapEvent } from "../../utils";

function buildLss(_ref, isFocused) {
  var disabled = _ref.disabled,
      isTouched = _ref.isTouched,
      isInvalid = _ref.isInvalid,
      lss = _ref.lss;
  return _objectSpread({
    position: 'relative',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'center',
    minHeight: '40px',
    border: 'regular',
    borderColor: isTouched && isInvalid ? 'danger' : isFocused ? 'secondary' : 'border',
    borderRadius: 'sm',
    bg: disabled ? 'disabled' : 'background',
    textScale: 'control',
    lineHeight: 1,
    color: disabled ? 'disabled' : undefined,
    boxShadow: function boxShadow(_ref2) {
      var theme = _ref2.theme;
      return isFocused && isTouched && isInvalid ? "inset 0 1px 1px ".concat(theme.colors.primaryShadow, ", 0 0 0px 2px ").concat(theme.colors.dangerShadow) : isFocused ? "inset 0 1px 1px ".concat(theme.colors.primaryShadow, ", 0 0 0 2px ").concat(theme.colors.secondaryShadow, ", 0 1px 0 ").concat(theme.colors.primaryText) : undefined;
    },
    cursor: disabled ? 'not-allowed' : undefined
  }, lss);
}

export var InputWrapper = React.forwardRef(function (_ref3, ref) {
  var onFocus = _ref3.onFocus,
      onBlur = _ref3.onBlur,
      props = _objectWithoutProperties(_ref3, ["onFocus", "onBlur"]);

  var _useState = useState(props.isFocused || false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  useEffect(function () {
    setIsFocused(props.isFocused || false);
  }, [props.isFocused]);
  return React.createElement(Box, Object.assign({}, props, {
    ref: ref,
    lss: buildLss(props, isFocused),
    onFocus: wrapEvent(onFocus, function () {
      return setIsFocused(true);
    }),
    onBlur: wrapEvent(onBlur, function () {
      return setIsFocused(false);
    })
  }));
});